export default __webpack_public_path__ + "static/media/Gloves of the Strange Beyond.7b1d74f1.jpg";